import React, { useEffect, useState } from "react";
import Controls from "./components/Controls";
import { Dialog } from "@mui/material";
import CardWindow from "./components/CardWindow";
import { useTheme } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import LeadActionsModal from "../../../../components/Modals/LeadActions/LeadActionsModal";
import { selectUserFullName } from "../../../../slices/userInfoSlice";
import { setViewingMortgage } from "../../../../slices/viewingMortgageSlice";
import { setViewingLeadReports } from "../../../../slices/teamReportsSlice";
import handleLeadNewFilterChanges from "./functions/filterNew";
import handleLeadTagFilterChanges from "./functions/filterTag";
import handleLeadTierFilterChanges from "./functions/filterTier";
import handleLeadTypeFilterChanges from "./functions/filterType";
import handleLeadSortMethodChanges from "./functions/sortMethod";
import { useDispatch, useSelector } from "react-redux";
import handleLeadSortCategoryChanges from "./functions/sortCategory";
import { removeNotificationFromMortgage } from "../../../../slices/teamMortgagesSlice";
import { selectTeamLeadTags } from "../../../../slices/teamAndUserSettingsSlice";
import { styled } from "@mui/material/styles";
import { selectViewingLead, setViewingLead, setViewingLeadTimeline } from "../../../../slices/viewingLeadSlice";
import { removeLeadNotification, removeNewLeadNotification, selectNewAwaitingActionCount, selectNewAwaitingUpdatesCount, selectNewClosingCount, selectNewInvestigatingCount } from "../../../../slices/userNotificationsSlice";
import { selectDashPerspective, selectDashUserFullName, selectLeadsFilteredBoolean, selectLeadStatusFilter, selectShowLeadActionsModal, selectViewingLeadActions, setLeadActionNavMenuSelection, setLeadsFilteredBoolean, setLeadStatusFilter, setShowLeadActionsModal, setViewingLeadActions } from "../../../../slices/sessionDataSlice";
import { selectFilteredMemberAwaitingActionLeads, selectFilteredMemberAwaitingUpdateLeads, selectFilteredMemberClosingLeads, selectFilteredMemberInvestigatingLeads, selectMemberAwaitingActionLeads, selectMemberAwaitingUpdateLeads, selectMemberClosingLeads, selectMemberInvestigatingLeads, setFilteredMemberAwaitingActionLeads, setFilteredMemberClosingLeads, setFilteredMemberInvestigatingLeads, setSortedMemberAwaitingActionLeads, setSortedMemberClosingLeads, setSortedMemberInvestigatingLeads } from "../../../../slices/memberAssignmentsSlice";
import { selectTeamClosingLeads, selectFilteredTeamClosingLeads, selectFilteredTeamInvestigatingLeads, selectTeamInvestigatingLeads, setFilteredTeamClosingLeads, setFilteredTeamInvestigatingLeads, setSortedTeamClosingLeads, setSortedTeamInvestigatingLeads, setSortedTeamAwaitingActionLeads, setFilteredTeamAwaitingActionLeads, selectTeamAwaitingActionLeads, selectFilteredTeamAwaitingActionLeads, selectTeamAwaitingUpdateLeads, selectFilteredTeamAwaitingUpdateLeads, removeNotificationFromLead, setFwdBckViewingLeads, setFwdBckFilteredViewingLeads } from "../../../../slices/teamActiveLeadsSlice";

const ActiveLeads = ({ teamId, userId }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()  

  const viewingLead = useSelector(selectViewingLead)
  const teamLeadTags = useSelector(selectTeamLeadTags)
  const userFullName = useSelector(selectUserFullName)
  const memberFullName = useSelector(selectDashUserFullName)
  const dashPerspective = useSelector(selectDashPerspective)
  const leadStatusFilter = useSelector(selectLeadStatusFilter)
  const viewingLeadActions = useSelector(selectViewingLeadActions)
  const showLeadActionsModal = useSelector(selectShowLeadActionsModal)
  
  const teamClosingLeads = useSelector(selectTeamClosingLeads)
  const teamInvestigatingLeads = useSelector(selectTeamInvestigatingLeads)
  const teamAwaitingActionLeads = useSelector(selectTeamAwaitingActionLeads)
  const teamAwaitingUpdateLeads = useSelector(selectTeamAwaitingUpdateLeads)
  const filteredTeamClosingLeads = useSelector(selectFilteredTeamClosingLeads)
  const memberInvestigatingLeads = useSelector(selectMemberInvestigatingLeads)
  const memberAwaitingActionLeads = useSelector(selectMemberAwaitingActionLeads)
  const filteredTeamInvestigatingLeads = useSelector(selectFilteredTeamInvestigatingLeads)
  const filteredTeamAwaitingActionLeads = useSelector(selectFilteredTeamAwaitingActionLeads)
  const filteredTeamAwaitingUpdateLeads = useSelector(selectFilteredTeamAwaitingUpdateLeads)
  const filteredMemberAwaitingActionLeads = useSelector(selectFilteredMemberAwaitingActionLeads)
  const filteredMemberAwaitingUpdateLeads = useSelector(selectFilteredMemberAwaitingUpdateLeads)
  const filteredMemberInvestigatingLeads = useSelector(selectFilteredMemberInvestigatingLeads)
  const filteredMemberClosingLeads = useSelector(selectFilteredMemberClosingLeads)
  const memberAwaitingUpdateLeads = useSelector(selectMemberAwaitingUpdateLeads)
  const newAwaitingUpdatesCount = useSelector(selectNewAwaitingUpdatesCount)
  const newAwaitingActionCount = useSelector(selectNewAwaitingActionCount)
  const newInvestigatingCount = useSelector(selectNewInvestigatingCount)
  const leadsFilteredBoolean = useSelector(selectLeadsFilteredBoolean)
  const memberClosingLeads = useSelector(selectMemberClosingLeads)
  const newClosingCount = useSelector(selectNewClosingCount)

  const [sortLoaded, setSortLoaded] = useState(true)
  const [leadNewFilter, setLeadNewFilter] = useState('false')
  const [leadTagFilter, setLeadTagFilter] = useState(['All'])
  const [leadTypeFilter, setLeadTypeFilter] = useState('All')
  const [leadTierFilter, setLeadTierFilter] = useState('All')
  const [leadSortMethod, setLeadSortMethod] = useState('High-Low')
  const [leadCategorySort, setLeadCategorySort] = useState('Date Discovered')
  
  useEffect(() => {
    setLeadTagFilter(['All'])
    setLeadTypeFilter('All')
    setLeadTierFilter('All')
    setLeadCategorySort('Date Discovered')
    setLeadSortMethod('High-Low')
  }, [dashPerspective])

  const handleLeadSortCategoryChange = async (event) => {
    setLeadCategorySort(event.target.value);
    setSortLoaded(false)
    let sortedLeads = {}
    let sortedFilteredLeads = {}
    if (leadTierFilter === 'All' && leadTypeFilter === 'All' && leadTagFilter[0] === 'All' && leadNewFilter === 'false') {
      if (dashPerspective === 'team') {
        sortedLeads = await handleLeadSortCategoryChanges(event.target.value, leadSortMethod, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads)
        dispatch( setSortedTeamAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedTeamInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedTeamClosingLeads(sortedLeads.closing) )
      } else {
        sortedLeads = await handleLeadSortCategoryChanges(event.target.value, leadSortMethod, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads)
        dispatch( setSortedMemberAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedMemberInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedMemberClosingLeads(sortedLeads.closing) )
      }
      setSortLoaded(true)
    } else {
      if (dashPerspective === 'team') {
        sortedFilteredLeads = await handleLeadSortCategoryChanges(event.target.value, leadSortMethod, filteredTeamAwaitingActionLeads, filteredTeamInvestigatingLeads, filteredTeamClosingLeads)
        dispatch( setFilteredTeamAwaitingActionLeads(sortedFilteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(sortedFilteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(sortedFilteredLeads.closing) )
        setSortLoaded(true)
        sortedLeads = await handleLeadSortCategoryChanges(event.target.value, leadSortMethod, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads)
        dispatch( setSortedTeamAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedTeamInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedTeamClosingLeads(sortedLeads.closing) )        
      } else {
        sortedFilteredLeads = await handleLeadSortCategoryChanges(event.target.value, leadSortMethod, filteredMemberAwaitingActionLeads, filteredMemberInvestigatingLeads, filteredMemberClosingLeads)
        dispatch( setFilteredMemberAwaitingActionLeads(sortedFilteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(sortedFilteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(sortedFilteredLeads.closing) )
        setSortLoaded(true)
        sortedLeads = await handleLeadSortCategoryChanges(event.target.value, leadSortMethod, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads)
        dispatch( setSortedMemberAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedMemberInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedMemberClosingLeads(sortedLeads.closing) )
      }
    }
  }
  const handleLeadSortMethodChange = async (event) => {
    setLeadSortMethod(event.target.value);
    setSortLoaded(false)
    let sortedLeads = {}
    let sortedFilteredLeads = {}
    if (leadTierFilter === 'All' && leadTypeFilter === 'All' && leadTagFilter[0] === 'All' && leadNewFilter === 'false') {
      if (dashPerspective === 'team') {
        sortedLeads = await handleLeadSortMethodChanges(event.target.value, leadCategorySort, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads)
        dispatch( setSortedTeamAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedTeamInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedTeamClosingLeads(sortedLeads.closing) )
        setSortLoaded(true)
      } else {
        sortedLeads = await handleLeadSortMethodChanges(event.target.value, leadCategorySort, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads)
        dispatch( setSortedMemberAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedMemberInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedMemberClosingLeads(sortedLeads.closing) )
        setSortLoaded(true)
      }
    } else {
      if (dashPerspective === 'team') {
        sortedFilteredLeads = await handleLeadSortMethodChanges(event.target.value, leadCategorySort, filteredTeamAwaitingActionLeads, filteredTeamInvestigatingLeads, filteredTeamClosingLeads)
        dispatch( setFilteredTeamAwaitingActionLeads(sortedFilteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(sortedFilteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(sortedFilteredLeads.closing) )
        setSortLoaded(true)
        sortedLeads = await handleLeadSortMethodChanges(event.target.value, leadCategorySort, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads)
        dispatch( setSortedTeamAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedTeamInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedTeamClosingLeads(sortedLeads.closing) )
      } else {
        sortedFilteredLeads = await handleLeadSortMethodChanges(event.target.value, leadCategorySort, filteredMemberAwaitingActionLeads, filteredMemberInvestigatingLeads, filteredMemberClosingLeads)
        dispatch( setFilteredMemberAwaitingActionLeads(sortedFilteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(sortedFilteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(sortedFilteredLeads.closing) )
        setSortLoaded(true)
        sortedLeads = await handleLeadSortMethodChanges(event.target.value, leadCategorySort, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads)
        dispatch( setSortedMemberAwaitingActionLeads(sortedLeads.awaitingAction) )
        dispatch( setSortedMemberInvestigatingLeads(sortedLeads.investigating) )
        dispatch( setSortedMemberClosingLeads(sortedLeads.closing) )
      }
    }
  }
  const handleLeadTierFilterChange = async (event) => {
    setSortLoaded(false)
    if (leadTypeFilter === 'All' && leadNewFilter === 'false' && leadTagFilter[0] === 'All' && event.target.value === 'All') {
      dispatch( setLeadsFilteredBoolean(true) )
      if (dashPerspective === 'team') {
        setLeadTierFilter(event.target.value);
        let filteredLeads = await handleLeadTierFilterChanges(event.target.value, filteredTeamAwaitingActionLeads, filteredTeamInvestigatingLeads, filteredTeamClosingLeads, leadTypeFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        setLeadTierFilter(event.target.value);
        let filteredLeads = await handleLeadTierFilterChanges(event.target.value, filteredMemberAwaitingActionLeads, filteredMemberInvestigatingLeads, filteredMemberClosingLeads, leadTypeFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    } else {
      dispatch( setLeadsFilteredBoolean(false) )
      if (dashPerspective === 'team') {
        setLeadTierFilter(event.target.value);
        let filteredLeads = await handleLeadTierFilterChanges(event.target.value, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads, leadTypeFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        setLeadTierFilter(event.target.value);
        let filteredLeads = await handleLeadTierFilterChanges(event.target.value, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads, leadTypeFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    }
  }
  const handleLeadTagFilterChange = async (event) => {
    setSortLoaded(false)
    if (event.target.value.length === 0) {
      setLeadTagFilter(['All'])
    } else {
      if (event.target.value[0] === 'All') {
        event.target.value.splice(0, 1)
      } else {
        let match = event.target.value.find(tag => tag === 'All')
        if (match) {
          event.target.value = ['All']
        }
      }
      setLeadTagFilter(event.target.value)
    }
    if (leadTypeFilter === 'All' && leadNewFilter === 'false' && leadTierFilter === 'All' && (leadTagFilter[0] === 'All' || event.target.value.length === 0)) {
      dispatch( setLeadsFilteredBoolean(true) )
      if (dashPerspective === 'team') {
        let filteredLeads = await handleLeadTagFilterChanges(event.target.value, filteredTeamAwaitingActionLeads, filteredTeamInvestigatingLeads, filteredTeamClosingLeads, leadNewFilter, leadTypeFilter, leadTierFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        let filteredLeads = await handleLeadTagFilterChanges(event.target.value, filteredMemberAwaitingActionLeads, filteredMemberInvestigatingLeads, filteredMemberClosingLeads, leadNewFilter, leadTypeFilter, leadTierFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    } else {
      dispatch( setLeadsFilteredBoolean(false) )
      if (dashPerspective === 'team') {
        let filteredLeads = await handleLeadTagFilterChanges(event.target.value, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads, leadNewFilter, leadTypeFilter, leadTierFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        let filteredLeads = await handleLeadTagFilterChanges(event.target.value, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads, leadNewFilter, leadTypeFilter, leadTierFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    }
  }
  const handleLeadStatusFilterChange = (event) => {
    dispatch( setLeadStatusFilter(event.target.value) )
    if (event.target.value === 'Awaiting Action') {
      dispatch( removeNewLeadNotification({status: 'awaitingAction', count: newAwaitingActionCount}) )
    } else if (event.target.value === 'Investigating') {
      dispatch( removeNewLeadNotification({status: 'investigating', count: newInvestigatingCount}) )
    } else if (event.target.value === 'Closing') {
      dispatch( removeNewLeadNotification({status: 'closing', count: newClosingCount}) )
    } else if (event.target.value === 'Awaiting PR Updates') {
      dispatch( removeNewLeadNotification({status: 'awaitingUpdates', count: newAwaitingUpdatesCount}) )
    }
  }
  const handleLeadNewFilterChange = async (event) => {
    setSortLoaded(false)
    if (leadTypeFilter === 'All' && leadTierFilter === 'All' && leadTagFilter[0] === 'All' && event.target.value === 'false') {
      dispatch( setLeadsFilteredBoolean(true) )
      if (dashPerspective === 'team') {
        setLeadNewFilter(event.target.value);
        let filteredLeads = await handleLeadNewFilterChanges(event.target.value, filteredTeamAwaitingActionLeads, filteredTeamInvestigatingLeads, filteredTeamClosingLeads, leadTierFilter, leadTagFilter, leadTypeFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        setLeadNewFilter(event.target.value);
        let filteredLeads = await handleLeadNewFilterChanges(event.target.value, filteredMemberAwaitingActionLeads, filteredMemberInvestigatingLeads, filteredMemberClosingLeads, leadTierFilter, leadTagFilter, leadTypeFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    } else {
      dispatch( setLeadsFilteredBoolean(false) )
      if (dashPerspective === 'team') {
        setLeadNewFilter(event.target.value);
        let filteredLeads = await handleLeadNewFilterChanges(event.target.value, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads, leadTierFilter, leadTagFilter, leadTypeFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        setLeadNewFilter(event.target.value);
        let filteredLeads = await handleLeadNewFilterChanges(event.target.value, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads, leadTierFilter, leadTagFilter, leadTypeFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    }
  }
  const handleLeadTypeFilterChange = async (event) => {
    setSortLoaded(false)
    if (leadTierFilter === 'All' && leadNewFilter === 'false' && leadTagFilter[0] === 'All' && event.target.value === 'All') {
      dispatch( setLeadsFilteredBoolean(true) )
      if (dashPerspective === 'team') {
        setLeadTypeFilter(event.target.value)
        let filteredLeads = await handleLeadTypeFilterChanges(event.target.value, filteredTeamAwaitingActionLeads, filteredTeamInvestigatingLeads, filteredTeamClosingLeads, leadTierFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        setLeadTypeFilter(event.target.value)
        let filteredLeads = await handleLeadTypeFilterChanges(event.target.value, filteredMemberAwaitingActionLeads, filteredMemberInvestigatingLeads, filteredMemberClosingLeads, leadTierFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    } else {
      dispatch( setLeadsFilteredBoolean(false) )
      if (dashPerspective === 'team') {
        setLeadTypeFilter(event.target.value)
        let filteredLeads = await handleLeadTypeFilterChanges(event.target.value, teamAwaitingActionLeads, teamInvestigatingLeads, teamClosingLeads, leadTierFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredTeamAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredTeamInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredTeamClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      } else {
        setLeadTypeFilter(event.target.value)
        let filteredLeads = await handleLeadTypeFilterChanges(event.target.value, memberAwaitingActionLeads, memberInvestigatingLeads, memberClosingLeads, leadTierFilter, leadNewFilter, leadTagFilter)
        dispatch( setFilteredMemberAwaitingActionLeads(filteredLeads.awaitingAction) )
        dispatch( setFilteredMemberInvestigatingLeads(filteredLeads.investigating) )
        dispatch( setFilteredMemberClosingLeads(filteredLeads.closing) )
        setSortLoaded(true)
      }
    }
  }

  const handleOpenLeadActionsModal = (destination, lead, leadMortgage) => {
    if (lead.notifCount && lead.notifCount !== 0) {
      if (lead.status === 'awaitingAction') {
        dispatch( removeLeadNotification({status: 'awaitingAction', count: 1}) )
        dispatch( removeNotificationFromLead({status: 'awaitingAction', leadId: lead._id}) )
      } else if (lead.status === 'investigating') {
        dispatch( removeLeadNotification({status: 'investigating', count: 1}) )
        dispatch( removeNotificationFromLead({status: 'investigating', leadId: lead._id}) )
      } else if (lead.status === 'closing') {
        dispatch( removeLeadNotification({status: 'closing', count: 1}) )
        dispatch( removeNotificationFromLead({status: 'closing', leadId: lead._id}) )
      } else {
        dispatch( removeLeadNotification({status: 'awaitingUpdates', count: 1}) )
        dispatch( removeNotificationFromLead({status: 'awaitingUpdates', leadId: lead._id}) )
      }
      dispatch( removeNotificationFromMortgage({mortgageId: leadMortgage._id}) )
    }
    dispatch( setViewingLeadReports(lead.reports) )
    dispatch( setViewingLead(lead) )
    if (leadsFilteredBoolean || dashPerspective !== 'team') {
      dispatch( setFwdBckFilteredViewingLeads(lead._id) )
    } else {
      dispatch( setFwdBckViewingLeads(lead._id) )
    }
    dispatch( setViewingMortgage(leadMortgage) )
    dispatch( setLeadActionNavMenuSelection(destination) )
    dispatch( setShowLeadActionsModal(true) )
    navigate(`/dashboard/investigations/${lead._id}`)
  }
  const handleCloseModal = () => {
    dispatch( setShowLeadActionsModal(false) )
    dispatch( setViewingLeadActions(false) )
    navigate(`/dashboard/investigations/`)
    dispatch( setViewingLead(null) )
    dispatch( setFwdBckViewingLeads(null) )
    dispatch( setViewingLeadTimeline(null) )
    dispatch( setFwdBckFilteredViewingLeads(null) )
  }

  useEffect(() => {
    if (viewingLeadActions) {
      dispatch( setShowLeadActionsModal(true) )
      navigate(`/dashboard/investigations/${viewingLead._id}`)
    }
  }, [viewingLead, viewingLeadActions, navigate, dispatch])

  const renderLoadingState = () => (
    <LoadingPanel>
      <CircularProgress sx={{ color: `${theme.palette.primary.main}` }} size={48} />
    </LoadingPanel>
  );

  const renderLeadWindow = ({
    unfilteredLeads,
    filteredLeads,
    status,
    user,
    requiresClosingLoaded = false,
  }) => {
    const baseFiltersClear =
      leadTierFilter === "All" &&
      leadTagFilter[0] === "All" &&
      leadTypeFilter === "All" &&
      leadNewFilter === "false";

    const awaitingActionFiltersClear =
      leadTierFilter === "All" &&
      leadTagFilter[0] === "All" &&
      leadNewFilter === "false";

    const filtersClear =
      status === "awaitingAction" ? awaitingActionFiltersClear : baseFiltersClear;

    const loaded =
      sortLoaded &&
      unfilteredLeads !== undefined &&
      (!requiresClosingLoaded || teamClosingLeads !== undefined);

    const filteredLoaded = sortLoaded && filteredLeads !== undefined;

    if (loaded && filtersClear) {
      return (
        <CardWindow
          teamLeads={unfilteredLeads}
          leadStatusFilter={leadStatusFilter}
          dashPerspective={dashPerspective}
          userFullName={userFullName}
          userId={userId}
          handleOpenLeadActionsModal={handleOpenLeadActionsModal}
          status={status}
          user={user}
          memberFullName={memberFullName}
          filtered={false}
        />
      );
    }

    if (filteredLoaded) {
      return (
        <CardWindow
          teamLeads={filteredLeads}
          leadStatusFilter={leadStatusFilter}
          dashPerspective={dashPerspective}
          userFullName={userFullName}
          userId={userId}
          handleOpenLeadActionsModal={handleOpenLeadActionsModal}
          status={status}
          user={user}
          memberFullName={memberFullName}
          filtered
        />
      );
    }

    return renderLoadingState();
  };

  const renderActiveQueue = () => {
    const isTeam = dashPerspective === "team";
    const isSelf = dashPerspective === userId;
    const scopedUser = isTeam ? "team" : isSelf ? "self" : memberFullName;

    if (leadStatusFilter === "Awaiting Action") {
      return isTeam
        ? renderLeadWindow({
            unfilteredLeads: teamAwaitingActionLeads,
            filteredLeads: filteredTeamAwaitingActionLeads,
            status: "awaitingAction",
            user: "team",
          })
        : renderLeadWindow({
            unfilteredLeads: memberAwaitingActionLeads,
            filteredLeads: filteredMemberAwaitingActionLeads,
            status: "awaitingAction",
            user: scopedUser,
          });
    }

    if (leadStatusFilter === "Investigating") {
      return isTeam
        ? renderLeadWindow({
            unfilteredLeads: teamInvestigatingLeads,
            filteredLeads: filteredTeamInvestigatingLeads,
            status: "investigating",
            user: "team",
            requiresClosingLoaded: true,
          })
        : renderLeadWindow({
            unfilteredLeads: memberInvestigatingLeads,
            filteredLeads: filteredMemberInvestigatingLeads,
            status: "investigating",
            user: scopedUser,
          });
    }

    if (leadStatusFilter === "Awaiting PR Updates") {
      return isTeam
        ? renderLeadWindow({
            unfilteredLeads: teamAwaitingUpdateLeads,
            filteredLeads: filteredTeamAwaitingUpdateLeads,
            status: "awaitingUpdate",
            user: "team",
            requiresClosingLoaded: true,
          })
        : renderLeadWindow({
            unfilteredLeads: memberAwaitingUpdateLeads,
            filteredLeads: filteredMemberAwaitingUpdateLeads,
            status: "awaitingUpdate",
            user: scopedUser,
          });
    }

    return isTeam
      ? renderLeadWindow({
          unfilteredLeads: teamClosingLeads,
          filteredLeads: filteredTeamClosingLeads,
          status: "closing",
          user: "team",
          requiresClosingLoaded: true,
        })
      : renderLeadWindow({
          unfilteredLeads: memberClosingLeads,
          filteredLeads: filteredMemberClosingLeads,
          status: "closing",
          user: scopedUser,
        });
  };

  return (
    <>
      <ActiveLeadsPage>
        <QueueWorkspace>{renderActiveQueue()}</QueueWorkspace>

        <ControlsPanel>
          <Controls
            leadStatusFilter={leadStatusFilter}
            handleLeadStatusFilterChange={handleLeadStatusFilterChange}
            leadCategorySort={leadCategorySort}
            handleLeadSortCategoryChange={handleLeadSortCategoryChange}
            leadSortMethod={leadSortMethod}
            handleLeadSortMethodChange={handleLeadSortMethodChange}
            leadTypeFilter={leadTypeFilter}
            handleLeadTierFilterChange={handleLeadTierFilterChange}
            handleLeadTypeFilterChange={handleLeadTypeFilterChange}
            handleLeadNewFilterChange={handleLeadNewFilterChange}
            leadNewFilter={leadNewFilter}
            leadTagFilter={leadTagFilter}
            handleLeadTagFilterChange={handleLeadTagFilterChange}
            teamLeadTags={teamLeadTags}
            memberAwaitingActionAmount={memberAwaitingActionLeads.length}
            memberInvestigatingAmount={memberInvestigatingLeads.length}
            memberClosingAmount={memberClosingLeads.length}
            memberAwaitingUpdateAmount={memberAwaitingUpdateLeads.length}
            teamAwaitingActionAmount={teamAwaitingActionLeads.length}
            teamInvestigatingAmount={teamInvestigatingLeads.length}
            teamClosingAmount={teamClosingLeads.length}
            teamAwaitingUpdateAmount={teamAwaitingUpdateLeads.length}
            dashPerspective={dashPerspective}
            leadTierFilter={leadTierFilter}
          />
        </ControlsPanel>
      </ActiveLeadsPage>

      <Dialog
        open={showLeadActionsModal}
        onClose={handleCloseModal}
        PaperProps={{
          sx: {
            width: "95%",
            minWidth: "140rem",
            maxWidth: "160rem",
            height: "fit-content",
            minHeight: "66rem",
            maxHeight: "95%",
            borderRadius: "0.8rem",
            overflow: "hidden",
          },
        }}
        tabIndex={-1}
      >
        <LeadActionsModal
          handleCloseModal={handleCloseModal}
          userId={userId}
          userFullName={userFullName}
          dashPerspective={dashPerspective}
          teamId={teamId}
        />
      </Dialog>
    </>
  );
}

export default ActiveLeads;

const ActiveLeadsPage = styled("main")(({ theme }) => ({
  height: "100%",
  width: "100%",
  padding: "1rem",
  display: "grid",
  gridTemplateRows: "4.6rem minmax(0, 1fr)",
  gridTemplateColumns: "minmax(0, 1fr) 18.5rem",
  gap: "1rem",
  background:
    "linear-gradient(180deg, rgba(248,250,252,0.98), rgba(241,245,249,0.94))",
}));

const QueueWorkspace = styled("section")({
  gridRow: "1 / 3",
  gridColumn: 1,
  minWidth: 0,
  minHeight: 0,
  height: "100%",
  maxHeight: "100%",
  overflow: "hidden",
  display: "grid",
  gridTemplateRows: "4.6rem minmax(0, 1fr)",
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: "1rem",
});

const ControlsPanel = styled("aside")({
  gridRow: "1 / 3",
  gridColumn: 2,
  minHeight: 0,
  height: "100%",
  overflowY: "auto",
  overflowX: "hidden",
  paddingRight: "0.2rem",

  "::-webkit-scrollbar": {
    width: "0.35rem",
  },

  "::-webkit-scrollbar-thumb": {
    borderRadius: "999px",
    background: "rgba(100,116,139,0.55)",
  },
});

const LoadingPanel = styled("section")(({ theme }) => ({
  gridRow: "1 / 3",
  gridColumn: 1,
  minHeight: "36rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "0.8rem",
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.96), rgba(248,250,252,0.9))",
  boxShadow: "0 0.8rem 1.8rem rgba(15, 23, 42, 0.055)",
}));
